export default __webpack_public_path__ + "static/media/Nerd_Leo.afd62ff9.png";